/**
 * Runtime env access + validation.
 * Imported once from src/index.js so a missing/misconfigured .env surfaces loudly at
 * boot instead of letting API requests silently hit `undefined/...` URLs.
 */
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IMAGE_ENDPOINT = process.env.REACT_APP_IMAGE_ENDPOINT;
export const APP_ENV = process.env.REACT_APP_ENV || 'production';

const missing = [];
if (!BASE_URL) missing.push('REACT_APP_BASE_URL');
if (!IMAGE_ENDPOINT) missing.push('REACT_APP_IMAGE_ENDPOINT');

if (missing.length) {
  console.error(
    `[env] Missing required env var(s): ${missing.join(', ')}. ` +
      `Copy .env.example to .env.local and run with the local config (see README).`
  );
}
